import React, { FC } from "react";
import styled, { css } from "styled-components";
import { SpinnerIcon } from "tombac-icons";
import { propStyling, PropsWithPropStyling, tombac } from "../../../shared";

export const spinnerStyles = css<PropsWithPropStyling>`
  color: ${({ theme }) => tombac.parse(theme.components.button.current?.color)};
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);

  ${propStyling}
`;

const Container = styled.span`
  ${spinnerStyles}
`;

export const Spinner: FC<PropsWithPropStyling> = (props) => (
  <Container aria-hidden>
    <SpinnerIcon spin />
  </Container>
);
